/**
 * Cart Promotions Module
 * Renders generic role promotions and the separate Staff promotion in the same cart location,
 * then creates one draft order containing any selected gifts.
 */
(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPromotionsCart);
  } else {
    initPromotionsCart();
  }

  function initPromotionsCart() {
    var data = window.__PROMOTIONS_DATA__;
    var container = document.getElementById('promotions-cart-container');
    if (!data || !container) return;

    var customerId = data.customerId;
    var locale = data.locale || 'en';
    var appBaseUrl = String(data.appBaseUrl || '').replace(/\/$/, '');
    var campaignBase = '/apps/gift-promotions';
    var campaignStore = window.PromotionStorage && window.PromotionStorage.forCustomer(customerId);
    var campaignSaved = campaignStore ? campaignStore.campaigns() : {};
    var promotionStates = [];
    var promotionChangeCallback = function() {};
    var validatePromotions = function() { return true; };
    var roleRefreshVersion = 0;
    var staffRefreshVersion = 0;
    var latestCart = null;

    var cartPromise = fetchJson('/cart.json').catch(function(error) {
      console.error('Failed to load cart for promotion eligibility:', error);
      return null;
    });

    cartPromise.then(function(cart) {
      var roleEligibilityPromise = getRoleEligibility(cart).catch(function(error) {
        console.error('Failed to check role promotion eligibility:', error);
        return { eligible: false, promotions: [] };
      });
      var staffEligibilityPromise = getStaffEligibility(cart).catch(function(error) {
        console.error('Failed to check Staff promotion eligibility:', error);
        return { eligible: false };
      });

      return Promise.all([roleEligibilityPromise, staffEligibilityPromise]).then(function(results) {
        var roleEligibility = results[0];
        var staffEligibility = results[1];
        container.innerHTML = '';
        addPromotionStyles();
        showApprovalNotice(roleEligibility);

        (roleEligibility.promotions || []).forEach(function(promotion) {
          var roleState = renderRolePromotion(container, promotion, locale, campaignSaved[promotion.id]);
          if (roleState) registerPromotionState(roleState);
        });

        if (staffEligibility && staffEligibility.eligible && staffEligibility.config) {
          var staffState = renderStaffPromotion(container, staffEligibility.config, locale, staffEligibility.triggerQuantity);
          if (staffState) registerPromotionState(staffState);
        }

        setupCheckoutHandling();
        subscribeToCartUpdates();
      });
    });

    function getRoleEligibility(cart) {
      if (!cart || !Array.isArray(cart.items)) return Promise.resolve({ eligible: false, promotions: [] });
      latestCart = cart;
      campaignSaved = campaignStore ? campaignStore.campaigns() : {};
      var submittedGrants = Object.keys(campaignSaved).reduce(function(grants, id) {
        if (campaignSaved[id].grant) grants[id] = campaignSaved[id].grant;
        return grants;
      }, {});

      return fetchJson(campaignBase + '/eligibility', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customerId: customerId,
          grants: submittedGrants,
          cartItems: cart.items.map(function(item) {
            return {
              variantId: item.variant_id,
              productId: item.product_id,
              quantity: item.quantity
            };
          })
        })
      }).then(function(result) {
        if (result.customerId !== undefined && String(result.customerId) !== String(customerId || '')) {
          throw new Error('Your sign-in has changed. Please reload this page.');
        }
        (result.invalidGrantIds || []).forEach(function(id) {
          if (campaignStore) campaignStore.clearApproval(id, submittedGrants[id]);
        });
        campaignSaved = campaignStore ? campaignStore.campaigns() : {};
        return result;
      });
    }

    function showApprovalNotice(result) {
      var previous = container.querySelector('.campaign-approval-notice');
      if (previous) previous.remove();
      var invalid = campaignStore ? campaignStore.invalidApprovalIds() : [];
      var id = invalid.find(function(id) {
        return !(result.promotions || []).some(function(promotion) { return promotion.id === id && promotion.promotional_price != null; });
      });
      if (!id) return;
      var notice = document.createElement('p'); notice.className = 'campaign-approval-notice promotion-warning';
      notice.setAttribute('role', 'status');
      notice.textContent = startsWithChinese(locale) ? '已儲存的優惠授權已失效。' : 'Your saved promotion approval is no longer valid. ';
      var link = document.createElement('a');
      link.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'pages/promotion?campaign=' + encodeURIComponent(id);
      link.textContent = startsWithChinese(locale) ? '重新輸入優惠碼' : 'Re-enter your promotion code';
      notice.appendChild(link); container.prepend(notice);
    }

    function getStaffEligibility(cart) {
      if (!cart || !Array.isArray(cart.items)) return Promise.resolve({ eligible: false });

      return fetchJson(appBaseUrl + '/api/promotions/staff/eligibility', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customerId: customerId,
          cartItems: cart.items.map(function(item) {
            return {
              variantId: item.variant_id,
              productId: item.product_id,
              quantity: item.quantity
            };
          })
        })
      });
    }

    function registerPromotionState(state) {
      state.onChange(promotionChangeCallback);
      promotionStates.push(state);
    }

    function findState(type) {
      for (var index = 0; index < promotionStates.length; index++) {
        if (promotionStates[index].type === type) return promotionStates[index];
      }
      return null;
    }

    function subscribeToCartUpdates() {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

      // AJAX cart updates replace section HTML without rerunning this deferred asset.
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
        refreshRolePromotions(event && event.cartData);
        return refreshStaffPromotion(event && event.cartData);
      });
    }

    function refreshRolePromotions(cartData) {
      var refreshVersion = ++roleRefreshVersion;
      var currentCartPromise = cartData && Array.isArray(cartData.items)
        ? Promise.resolve(cartData)
        : fetchJson('/cart.json');

      return currentCartPromise
        .then(getRoleEligibility)
        .then(function(roleEligibility) {
          if (refreshVersion !== roleRefreshVersion) return;

          var previousSelections = {};
          promotionStates.forEach(function(state) {
            if (state.category === 'role') previousSelections[state.promotionId] = state.getSnapshot();
          });
          promotionStates = promotionStates.filter(function(state) { return state.category !== 'role'; });
          container.querySelectorAll('.role-promotion-card').forEach(function(card) { card.remove(); });

          (roleEligibility.promotions || []).forEach(function(promotion) {
            var roleState = renderRolePromotion(
              container,
              promotion,
              locale,
              previousSelections[promotion.id]
            );
            if (roleState) registerPromotionState(roleState);
          });

          showApprovalNotice(roleEligibility);
          validatePromotions(true);
        })
        .catch(function(error) {
          if (refreshVersion !== roleRefreshVersion) return;
          console.error('Failed to refresh role promotions after cart update:', error);
        });
    }

    function refreshStaffPromotion(cartData) {
      var refreshVersion = ++staffRefreshVersion;
      var cartPromise = cartData && Array.isArray(cartData.items)
        ? Promise.resolve(cartData)
        : fetchJson('/cart.json');

      return cartPromise
        .then(getStaffEligibility)
        .then(function(staffEligibility) {
          if (refreshVersion !== staffRefreshVersion) return;

          var previousState = findState('staff');
          var previousSelection = previousState ? previousState.getSnapshot() : null;
          promotionStates = promotionStates.filter(function(state) { return state.type !== 'staff'; });
          var previousCard = container.querySelector('.staff-promotion-card');
          if (previousCard) previousCard.remove();

          if (staffEligibility && staffEligibility.eligible && staffEligibility.config) {
            var staffState = renderStaffPromotion(
              container,
              staffEligibility.config,
              locale,
              staffEligibility.triggerQuantity,
              previousSelection
            );
            if (staffState) registerPromotionState(staffState);
          }

          validatePromotions(true);
        })
        .catch(function(error) {
          if (refreshVersion !== staffRefreshVersion) return;
          console.error('Failed to refresh Staff promotion after cart update:', error);
        });
    }

    function setupCheckoutHandling() {
      function validateAll(showWarnings) {
        var valid = true;
        promotionStates.forEach(function(state) {
          if (!state.validate(showWarnings)) valid = false;
        });
        var selectedOffers = promotionStates.filter(function(state) { return state.category === 'role' && state.getTotal() > 0; });
        var multiWarning = container.querySelector('.campaign-multiple-warning');
        if (multiWarning) multiWarning.remove();
        if (selectedOffers.length > 1) {
          valid = false;
          if (showWarnings) {
            multiWarning = document.createElement('p'); multiWarning.className = 'campaign-multiple-warning promotion-warning';
            multiWarning.setAttribute('role', 'alert');
            multiWarning.textContent = startsWithChinese(locale) ? '每張訂單只能選擇一項此類優惠。請清除其他優惠的禮品。' : 'Choose gifts from only one of these promotions per checkout. Clear the other offer selections.';
            container.appendChild(multiWarning);
          }
        }
        var oldPreview = container.querySelector('.campaign-price-preview');
        if (oldPreview) oldPreview.remove();
        var selectedPriced = promotionStates.filter(function(state) { return state.category === 'role' && state.getTotal() > 0 && state.price != null; });
        if (selectedPriced.length === 1 && latestCart) {
          var selected = selectedPriced[0];
          var quantity = latestCart.items.reduce(function(total, item) { return String(item.product_id) === String(selected.pricingProductId).split('/').pop() ? total + item.quantity : total; }, 0);
          var preview = document.createElement('p'); preview.className = 'campaign-price-preview';
          preview.textContent = (startsWithChinese(locale) ? '優惠產品小計（結帳時套用）：HK$' : 'Promotional product subtotal (applied at checkout): HK$') + (quantity * selected.price).toFixed(2) + (startsWithChinese(locale) ? ' + 免費禮品。其他商品及運費另計。' : ' + free gifts. Other items and shipping are additional.');
          container.appendChild(preview);
        }
        setCheckoutPromotionDisabled(!valid);
        return valid;
      }

      validatePromotions = validateAll;
      promotionChangeCallback = function() {
        promotionStates.forEach(function(state) {
          if (state.category === 'role' && campaignStore) campaignStore.saveSelection(state.promotionId, state.getSnapshot().promotionItems);
        });
        campaignSaved = campaignStore ? campaignStore.campaigns() : {};
        validateAll(true);
      };

      function hasSelectedGifts() {
        return promotionStates.some(function(state) { return state.getTotal() > 0; });
      }

      promotionStates.forEach(function(state) {
        state.onChange(promotionChangeCallback);
      });
      validateAll(false);

      var cartForm = document.getElementById('cart');
      if (cartForm) {
        cartForm.addEventListener('submit', function(event) {
          if (!hasSelectedGifts()) return;
          if (!promotionStates.some(function(state) { return state.category === 'role' && state.getTotal() > 0; })) {
            if (!validateAll(true)) event.preventDefault();
            return;
          }
          event.preventDefault();
          if (!validateAll(true)) return;
          var button = event.submitter || document.getElementById('normal-checkout-btn') || document.querySelector('[name="checkout"]');
          if (button) createDraftOrder(button, null);
        });
      }

      document.addEventListener('click', function(event) {
        var sfButton = document.getElementById('sf-checkout-btn');
        var normalButton = document.getElementById('normal-checkout-btn') || document.querySelector('[name="checkout"]');
        var clickedSf = sfButton && (event.target === sfButton || sfButton.contains(event.target));
        var clickedNormal = normalButton && (event.target === normalButton || normalButton.contains(event.target));

        if (!clickedSf && !clickedNormal) return;
        if (!hasSelectedGifts()) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        if (!validateAll(true)) return;

        var shippingAddress = null;
        if (clickedSf) {
          var checkedAddress = document.querySelector('#select-checkout input[name="result"]:checked');
          if (checkedAddress) shippingAddress = checkedAddress.value;
        }

        createDraftOrder(clickedSf ? sfButton : normalButton, shippingAddress);
      }, true);

      function createDraftOrder(triggerButton, shippingAddress) {
        if (triggerButton.dataset.promotionPending === 'true') return;
        triggerButton.dataset.promotionPending = 'true';
        var originalHtml = triggerButton.innerHTML;
        var loadingText = startsWithChinese(locale) ? '處理中...' : 'Processing...';
        var textColor = triggerButton.id === 'sf-checkout-btn' ? '#fff' : '#666';
        triggerButton.disabled = true;
        triggerButton.innerHTML = '<span style="display:block;padding:12px 24px;font-size:15px;color:' + textColor + ';text-align:center;">' + loadingText + '</span>';

        fetchJson('/cart.json').then(function(cart) {
          var staffState = findState('staff');
          var promotionSelections = promotionStates
            .filter(function(state) { return state.category === 'role'; })
            .map(function(state) { return state.getSelection(); })
            .filter(Boolean);
          promotionSelections.forEach(function(selection) { selection.grant = (campaignSaved[selection.promotionId] || {}).grant; });
          var payload = {
            cartItems: cart.items.map(function(item) {
              return {
                variantId: item.variant_id,
                productId: item.product_id,
                quantity: item.quantity,
                properties: item.properties
              };
            }),
            promotionItems: [],
            promotionSelections: promotionSelections,
            staffPromotion: staffState ? staffState.getSelection() : null,
            cartNote: getCartNote(),
            customerId: customerId,
            locale: locale
          };
          if (shippingAddress) payload.shippingAddress = shippingAddress;

          return fetchJson(promotionSelections.length ? campaignBase + '/draft-order' : appBaseUrl + '/api/promotions/draft-order', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });
        }).then(function(result) {
          if (!result.success || !result.invoiceUrl) {
            throw new Error(result.error || 'Failed to create draft order');
          }
          window.location.href = result.invoiceUrl;
        }).catch(function(error) {
          console.error('Promotion draft order error:', error);
          showPromotionError(container, error.message || 'An error occurred. Please try again.');
          triggerButton.disabled = false;
          delete triggerButton.dataset.promotionPending;
          triggerButton.innerHTML = originalHtml;
        });
      }
    }
  }

  function renderRolePromotion(container, config, locale, initialSelection) {
    var products = config.products || [];
    if (products.length === 0) return null;

    var maxQuantity = positiveInteger(config.max_total_quantity, 2);
    var wrapper = document.createElement('section');
    wrapper.className = 'cart-promotion-card role-promotion-card';
    wrapper.dataset.promotionId = config.id;

    var title = getLocalizedText(config.table_titles, locale) || 'Promotion';
    wrapper.setAttribute('aria-label', title);
    var subtitle = getLocalizedText(config.table_subtitles, locale);
    var quantityLabel = getLocalizedText(config.qty_labels, locale) || 'Qty:';
    var html = '<h3 class="cart-promotion-title">' + escapeHtml(title) + '</h3>';
    if (subtitle) html += '<p class="cart-promotion-subtitle">' + escapeHtml(subtitle) + '</p>';
    if (config.promotional_price != null) html += '<p class="cart-promotion-subtitle">' + (startsWithChinese(locale) ? '選擇此優惠的禮品後，合資格產品每件優惠價：HK$' : 'Select gifts from this offer to receive the qualifying product at HK$') + escapeHtml(Number(config.promotional_price).toFixed(2)) + (startsWithChinese(locale) ? '。優惠將於結帳套用。' : ' per unit. Applied at checkout.') + '</p>';
    html += '<div class="promo-products-grid">';

    products.forEach(function(product) {
      var productTitle = getLocalizedText(product.titles, locale) || product.shopify_product_title || '';
      var imageUrl = product.shopify_image_url || product.image_url || '';
      html += '<div class="promo-product-card">';
      if (imageUrl) {
        html += '<img class="promo-product-image" src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(productTitle) + '" loading="lazy">';
      }
      html += '<p class="promo-product-title">' + escapeHtml(productTitle) + '</p>';
      html += '<div class="promo-quantity-row"><label>' + escapeHtml(quantityLabel) + '</label>';
      html += '<input type="number" class="promo-role-qty-input" data-key="' + escapeHtml(product.key) + '" ';
      html += 'data-title="' + escapeHtml(productTitle) + '" data-variant-id="' + escapeHtml(product.shopify_variant_id || '') + '" ';
      html += 'min="0" max="' + maxQuantity + '" value="0"></div></div>';
    });

    html += '</div>';
    html += '<div class="promotion-warning" role="alert" hidden></div>';
    html += '<div class="promotion-total">' + (startsWithChinese(locale) ? '已選擇：' : 'Selected: ') + '<strong class="promotion-total-value">0</strong> / ' + maxQuantity + '</div>';
    wrapper.innerHTML = html;
    container.insertBefore(wrapper, container.querySelector('.staff-promotion-card'));

    var inputs = wrapper.querySelectorAll('.promo-role-qty-input');
    var warning = wrapper.querySelector('.promotion-warning');
    var totalDisplay = wrapper.querySelector('.promotion-total-value');
    var changeCallback = function() {};

    Array.prototype.forEach.call(inputs, function(input) {
      input.addEventListener('input', function() {
        clampQuantity(input, maxQuantity);
        changeCallback();
      });
    });

    if (initialSelection && Array.isArray(initialSelection.promotionItems)) {
      initialSelection.promotionItems.forEach(function(item) {
        Array.prototype.forEach.call(inputs, function(input) {
          if (input.dataset.key === item.key) input.value = positiveInteger(item.quantity, 0);
        });
      });
    }

    return {
      type: 'role:' + config.id,
      category: 'role',
      promotionId: config.id,
      price: config.promotional_price,
      pricingProductId: config.pricing_product_id,
      getTotal: function() { return sumInputs(inputs); },
      validate: function(showWarning) {
        var total = sumInputs(inputs);
        totalDisplay.textContent = total;
        var valid = total <= maxQuantity;
        setWarning(warning, valid ? '' : quantityLimitMessage(locale, maxQuantity), showWarning && !valid);
        return valid;
      },
      collect: function() {
        var items = [];
        Array.prototype.forEach.call(inputs, function(input) {
          var quantity = positiveInteger(input.value, 0);
          if (quantity > 0) {
            var item = { key: input.dataset.key, title: input.dataset.title, quantity: quantity };
            if (input.dataset.variantId) item.shopify_variant_id = input.dataset.variantId;
            items.push(item);
          }
        });
        return items;
      },
      getSelection: function() {
        var items = this.collect();
        return items.length > 0 ? { promotionId: config.id, promotionItems: items } : null;
      },
      getSnapshot: function() {
        return { promotionId: config.id, promotionItems: this.collect() };
      },
      onChange: function(callback) { changeCallback = callback; }
    };
  }

  function renderStaffPromotion(container, config, locale, triggerQuantity, initialSelection) {
    var options = Array.isArray(config.options) ? config.options : [];
    var numberOfSets = positiveInteger(triggerQuantity, 1);
    if (options.length !== 2 || numberOfSets < 1) return null;

    var wrapper = document.createElement('section');
    wrapper.className = 'cart-promotion-card staff-promotion-card';
    wrapper.setAttribute('aria-label', 'Promotion (Staff)');
    var labels = getStaffLabels(locale);
    Object.keys(config.storefront_text || {}).forEach(function(key) {
      labels[key] = getStaffText(config.storefront_text[key], locale, labels[key]);
    });
    wrapper.setAttribute('aria-label', labels.title || 'Promotion (Staff)');
    var html = '<h3 class="cart-promotion-title">' + escapeHtml(labels.title) + '</h3>';
    html += '<p class="cart-promotion-subtitle">' + escapeHtml(labels.chooseOption) + '</p>';
    html += '<p class="cart-promotion-subtitle">' + escapeHtml(labels.oneOffer) + '</p>';
    html += '<div class="staff-option-grid">';

    options.forEach(function(option, optionIndex) {
      var optionNumber = optionIndex + 1;
      var quantityPerSet = positiveInteger(option.max_total_quantity, 1);
      var maxQuantity = quantityPerSet * numberOfSets;
      html += '<label class="staff-option-choice" for="staff-promotion-option-' + optionNumber + '">';
      html += '<input type="radio" name="staff-promotion-option" id="staff-promotion-option-' + optionNumber + '" value="' + escapeHtml(option.key) + '">';
      html += '<span><strong>' + escapeHtml(getStaffText(option.titles, locale, labels.option + ' ' + (optionIndex === 0 ? 'A' : 'B'))) + '</strong>';
      var description = getStaffText(option.descriptions, locale, option.description || '');
      if (description) html += '<span class="staff-option-description">' + escapeHtml(description) + '</span>';
      html += '<small>' + escapeHtml(formatStaffLimit(labels.upTo, quantityPerSet, numberOfSets, maxQuantity)) + '</small></span></label>';
    });
    html += '</div>';

    options.forEach(function(option, optionIndex) {
      var maxQuantity = positiveInteger(option.max_total_quantity, 1) * numberOfSets;
      html += '<div class="staff-option-products" data-option-key="' + escapeHtml(option.key) + '" hidden>';
      html += '<h4>' + escapeHtml(labels.chooseGifts) + '</h4><div class="promo-products-grid">';
      (option.products || []).forEach(function(product) {
        var productTitle = getLocalizedText(product.titles, locale) || product.shopify_product_title || '';
        html += '<div class="promo-product-card">';
        if (product.shopify_image_url) {
          html += '<img class="promo-product-image" src="' + escapeHtml(product.shopify_image_url) + '" alt="' + escapeHtml(productTitle) + '" loading="lazy">';
        }
        html += '<p class="promo-product-title">' + escapeHtml(productTitle) + '</p>';
        html += '<div class="promo-quantity-row"><label>' + escapeHtml(labels.quantity) + '</label>';
        html += '<input type="number" class="promo-staff-qty-input" data-option-key="' + escapeHtml(option.key) + '" ';
        html += 'data-key="' + escapeHtml(product.key) + '" data-title="' + escapeHtml(productTitle) + '" ';
        html += 'data-variant-id="' + escapeHtml(product.shopify_variant_id || '') + '" min="0" max="' + maxQuantity + '" value="0"></div></div>';
      });
      html += '</div><div class="promotion-total">' + escapeHtml(labels.selected) + ' <strong class="staff-option-total">0</strong> / ' + maxQuantity + '</div></div>';
    });

    html += '<div class="promotion-warning" role="alert" hidden></div>';
    wrapper.innerHTML = html;
    container.appendChild(wrapper);

    var radios = wrapper.querySelectorAll('input[name="staff-promotion-option"]');
    var panels = wrapper.querySelectorAll('.staff-option-products');
    var allInputs = wrapper.querySelectorAll('.promo-staff-qty-input');
    var warning = wrapper.querySelector('.promotion-warning');
    var selectedOptionKey = '';
    var changeCallback = function() {};

    Array.prototype.forEach.call(radios, function(radio) {
      radio.addEventListener('change', function() {
        selectedOptionKey = radio.value;
        Array.prototype.forEach.call(allInputs, function(input) { input.value = 0; });
        Array.prototype.forEach.call(panels, function(panel) {
          panel.hidden = panel.dataset.optionKey !== selectedOptionKey;
        });
        updateOptionTotals();
        changeCallback();
      });
    });

    Array.prototype.forEach.call(allInputs, function(input) {
      input.addEventListener('input', function() {
        var option = findOption(config.options, input.dataset.optionKey);
        clampQuantity(input, positiveInteger(option && option.max_total_quantity, 1) * numberOfSets);
        updateOptionTotals();
        changeCallback();
      });
    });

    function selectedInputs() {
      return wrapper.querySelectorAll('.promo-staff-qty-input[data-option-key="' + cssAttributeEscape(selectedOptionKey) + '"]');
    }

    function updateOptionTotals() {
      Array.prototype.forEach.call(panels, function(panel) {
        var inputs = panel.querySelectorAll('.promo-staff-qty-input');
        panel.querySelector('.staff-option-total').textContent = sumInputs(inputs);
      });
    }

    restoreSelection(initialSelection);

    function restoreSelection(selection) {
      if (!selection || !selection.selectedOption) return;

      Array.prototype.forEach.call(radios, function(radio) {
        if (radio.value === selection.selectedOption) {
          radio.checked = true;
          selectedOptionKey = radio.value;
        }
      });
      if (!selectedOptionKey) return;

      Array.prototype.forEach.call(panels, function(panel) {
        panel.hidden = panel.dataset.optionKey !== selectedOptionKey;
      });
      (selection.promotionItems || []).forEach(function(item) {
        Array.prototype.forEach.call(allInputs, function(input) {
          if (input.dataset.optionKey === selectedOptionKey && input.dataset.key === item.key) {
            input.value = positiveInteger(item.quantity, 0);
          }
        });
      });
      updateOptionTotals();
    }

    return {
      type: 'staff',
      getTotal: function() { return selectedOptionKey ? sumInputs(selectedInputs()) : 0; },
      validate: function(showWarning) {
        if (!selectedOptionKey) {
          setWarning(warning, '', false);
          return true;
        }
        var option = findOption(config.options, selectedOptionKey);
        var maxQuantity = positiveInteger(option && option.max_total_quantity, 1) * numberOfSets;
        var valid = sumInputs(selectedInputs()) <= maxQuantity;
        setWarning(warning, valid ? '' : quantityLimitMessage(locale, maxQuantity), showWarning && !valid);
        return valid;
      },
      collect: function() {
        var items = [];
        if (!selectedOptionKey) return items;
        Array.prototype.forEach.call(selectedInputs(), function(input) {
          var quantity = positiveInteger(input.value, 0);
          if (quantity > 0) {
            items.push({
              key: input.dataset.key,
              title: input.dataset.title,
              shopify_variant_id: input.dataset.variantId,
              quantity: quantity
            });
          }
        });
        return items;
      },
      getSelection: function() {
        var items = this.collect();
        return items.length > 0 ? { selectedOption: selectedOptionKey, promotionItems: items } : null;
      },
      getSnapshot: function() {
        return { selectedOption: selectedOptionKey, promotionItems: this.collect() };
      },
      onChange: function(callback) { changeCallback = callback; }
    };
  }

  function addPromotionStyles() {
    if (document.getElementById('cart-promotions-styles')) return;
    var style = document.createElement('style');
    style.id = 'cart-promotions-styles';
    style.textContent =
      '.cart-promotion-card{background:#fff;border:1px solid #e5e5e5;border-radius:12px;padding:24px;margin-bottom:20px;}' +
      '.cart-promotion-title{margin:0 0 4px;font-size:18px;font-weight:700;color:#333;text-align:center;}' +
      '.cart-promotion-subtitle{margin:0 0 20px;font-size:14px;color:#666;text-align:center;}' +
      '.promo-products-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:16px;}' +
      '.promo-product-card{border:1px solid #e5e5e5;border-radius:8px;padding:16px;text-align:center;background:#fafafa;}' +
      '.promo-product-image{width:160px;height:160px;object-fit:contain;margin:0 auto 10px;display:block;}' +
      '.promo-product-title{margin:0 0 12px;font-size:14px;font-weight:600;color:#333;line-height:1.3;}' +
      '.promo-quantity-row{display:flex;align-items:center;justify-content:center;gap:8px;}' +
      '.promo-quantity-row label{font-size:13px;color:#555;}' +
      '.promo-quantity-row input{width:64px;padding:6px 8px;border:1px solid #ccc;border-radius:6px;text-align:center;font-size:14px;}' +
      '.promotion-warning{margin-top:12px;padding:8px 12px;background:#fff3cd;border:1px solid #ffc107;border-radius:6px;font-size:13px;color:#856404;text-align:center;}' +
      '.promotion-total{margin-top:12px;text-align:center;font-size:14px;color:#555;}' +
      '.staff-option-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:12px;margin-bottom:20px;}' +
      '.staff-option-choice{display:flex;align-items:flex-start;gap:10px;border:2px solid #ddd;border-radius:10px;padding:16px;cursor:pointer;background:#fafafa;}' +
      '.staff-option-choice:has(input:checked){border-color:#2b72d8;background:#f2f7ff;}' +
      '.staff-option-choice input{margin-top:4px;}' +
      '.staff-option-choice strong,.staff-option-choice small,.staff-option-description{display:block;}' +
      '.staff-option-choice strong{font-size:15px;color:#333;}' +
      '.staff-option-description{margin-top:5px;font-size:14px;color:#555;white-space:pre-line;}' +
      '.staff-option-choice small{margin-top:7px;color:#666;}' +
      '.staff-option-products h4{margin:0 0 12px;font-size:15px;color:#333;text-align:center;}' +
      '@media screen and (max-width:749px){.cart-promotion-card{padding:18px}.promo-products-grid,.staff-option-grid{grid-template-columns:repeat(2,minmax(0,1fr));}.promo-product-image{width:120px;height:120px;}}' +
      '@media screen and (max-width:420px){.staff-option-grid{grid-template-columns:1fr;}}';
    document.head.appendChild(style);
  }

  function fetchJson(url, options) {
    return fetch(url, options).then(function(response) {
      return response.json().catch(function() { return {}; }).then(function(body) {
        if (!response.ok) throw new Error(body.error || 'Request failed');
        return body;
      });
    });
  }

  function getLocalizedText(values, locale) {
    if (!values) return '';
    if (values[locale]) return values[locale];
    var normalized = String(locale || 'en').replace('_', '-');
    var language = normalized.split('-')[0];
    if (language === 'zh') return values['zh-TW'] || values['zh-CN'] || values.en || '';
    return values[language] || values.en || '';
  }

  function getStaffText(values, locale, fallback) {
    var normalized = String(locale || 'en').replace(/_/g, '-').toLowerCase();
    var key = /^(sc|zh-(cn|sg|hans)(-|$))/.test(normalized) ? 'zh-CN'
      : /^(tc|zh)/.test(normalized) ? 'zh-TW' : 'en';
    if (values && typeof values[key] === 'string') return values[key];
    return fallback || '';
  }

  function getStaffLabels(locale) {
    if (startsWithChinese(locale)) {
      return {
        title: 'M3CRC Family & Friends 健康計劃',
        chooseOption: '購買 M3CRC 非入侵性大腸癌風險檢測 1盒，可獲贈 G-NiiB 健康禮遇乙份',
        oneOffer: '每張訂單只能選擇一項禮遇',
        option: '禮遇',
        upTo: '每套可選 {perSet} 件；{setCount} 套共可選 {total} 件禮品',
        chooseGifts: '選擇禮品及數量',
        quantity: '數量：',
        selected: '已選擇：'
      };
    }
    return {
      title: 'M3CRC Family & Friends Health Programme',
      chooseOption: 'Purchase 1 box of the M3CRC non-invasive colorectal cancer risk test and receive one G-NiiB health offer.',
      oneOffer: 'Only one offer can be selected per order.',
      option: 'Offer',
      upTo: '{perSet} gift item(s) per set; {setCount} set(s) allow {total} in total',
      chooseGifts: 'Choose gifts and quantities',
      quantity: 'Qty:',
      selected: 'Selected:'
    };
  }

  function formatStaffLimit(template, quantityPerSet, numberOfSets, maxQuantity) {
    return String(template || '')
      .replace(/\{perSet\}/g, quantityPerSet)
      .replace(/\{setCount\}/g, numberOfSets)
      .replace(/\{total\}/g, maxQuantity);
  }

  function findOption(options, key) {
    for (var index = 0; index < options.length; index++) {
      if (options[index].key === key) return options[index];
    }
    return null;
  }

  function sumInputs(inputs) {
    var total = 0;
    Array.prototype.forEach.call(inputs, function(input) {
      total += positiveInteger(input.value, 0);
    });
    return total;
  }

  function clampQuantity(input, maxQuantity) {
    var quantity = parseInt(input.value, 10);
    if (!Number.isFinite(quantity) || quantity < 0) quantity = 0;
    if (quantity > maxQuantity) quantity = maxQuantity;
    input.value = quantity;
  }

  function positiveInteger(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isInteger(parsed) && parsed >= 0 ? parsed : fallback;
  }

  function setWarning(element, message, visible) {
    element.textContent = message;
    element.hidden = !visible;
  }

  function quantityLimitMessage(locale, maxQuantity) {
    return startsWithChinese(locale)
      ? '已超過最大數量限制 (' + maxQuantity + ')'
      : 'Please select no more than ' + maxQuantity + ' gift item(s).';
  }

  function setCheckoutPromotionDisabled(disabled) {
    var button = document.querySelector('button[form="cart"]');
    if (!button) return;
    if (disabled) {
      if (!button.disabled) button.dataset.promotionDisabled = 'true';
      button.disabled = true;
    } else if (button.dataset.promotionDisabled === 'true') {
      button.disabled = false;
      delete button.dataset.promotionDisabled;
    }
  }

  function getCartNote() {
    var note = document.getElementById('Cart-note');
    return note ? note.value : '';
  }

  function showPromotionError(container, message) {
    var oldError = container.querySelector('.promotion-global-error');
    if (oldError) oldError.remove();
    var error = document.createElement('div');
    error.className = 'promotion-global-error promotion-warning';
    error.style.background = '#f8d7da';
    error.style.borderColor = '#f5c6cb';
    error.style.color = '#721c24';
    error.textContent = message;
    container.appendChild(error);
  }

  function startsWithChinese(locale) {
    return String(locale || '').toLowerCase().indexOf('zh') === 0;
  }

  function cssAttributeEscape(value) {
    return String(value || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
})();
